import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { downLoadApp, getOssImageUrl } from '@/utils/utils';
import { indexUBT } from '@/utils/pageUbt';
import { DOWNLOAD_IMG } from '@/constants/config';
import './header.less';

interface Props {
  scene?: 'main' | 'sitter';
  styleType?: string; // 头部样式：light / black
  onOpenClick?: () => void;
}

const Header: FC<Props> = (props) => {
  const {
    scene = 'main',
    styleType = 'black',
    onOpenClick,
  } = props;

  return (
    <div className={classNames({
      'header-con': styleType === 'black',
      'header-con-light': styleType === 'light',
    })}>
      <img
        className={classNames({
          'header-con-img': styleType === 'black',
          'header-con-light-img': styleType === 'light',
        })}
        src={DOWNLOAD_IMG.INTRO_VIDEO} />
      <div className={classNames({
        'header-con-right': styleType === 'black',
        'header-con-light-right': styleType === 'light',
      })}>
        <div className={classNames({
          'header-con-intro': styleType === 'black',
          'header-con-light-intro': styleType === 'light',
        })}>
          <div className={classNames({
            'header-con-intro-t': styleType === 'black',
            'header-con-light-intro-t': styleType === 'light',
          })}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              // if (REACT_APP_ENV === 'pro') return;
              // if (window?.firstScreenEndTime) {
              //   window?.alert(window.firstScreenEndTime);
              // }
            }}>街猫{scene === 'sitter' ? 'APP' : ''}</div>
          <div className={classNames({
            'header-con-intro-b': styleType === 'black',
            'header-con-light-intro-b': styleType === 'light',
          })}>流浪猫云喂养绝育领养</div>
        </div>
        <div
          className='download-btn'
          id="download-btn-header"
          onClick={useCallback(() => {
            if (onOpenClick) {
              onOpenClick();
              return;
            }
            downLoadApp({
              data: {},
              clipboardStr: '',
              selector: '#download-btn-header',
            });
            indexUBT.clickButton({
              businessInfo: {},
              buttonName: 'miaowa_h5_index_appdakai_cli',
            });
          }, [])
          }>打开看看</div>
      </div>
    </div >
  );
};

export default Header;
